import React from "react";
import { Alert, Button, Card, Col, Form, Nav, Row } from "react-bootstrap";
import Footer from "../components/Footer";

const InterviewsQA = () => {
  return (
    <>
      <Row className="mx-0 all-courses">
        <Col md={9}>
          <Card className="shadow">
            <Card.Body>
              <h4>Interview Questions & Answers</h4>
              <p>
                We are going to post all types of interview questions like
                general, programming etc, daily (Monday - Friday) 1 interview
                question(s). On this page you will find different threads where
                you can discuss various topics related to the interview
                preparation.
              </p>
              <h5>Today's Interview Question</h5>
              <p className="fw-bold">1. Why should we hire you?</p>
              <Form.Control
                as={`textarea`}
                className="bg-interview"
                placeholder="Write your answer here..."
                rows={8}
              />
              <Button variant="success" size="sm" className="px-5 my-3">
                Submit your answer
              </Button>
            </Card.Body>
            <Card.Footer>
              <h5>Related Answers</h5>
              <Alert variant="secondary">
                <Row>
                  <Col sm={1} className="pe-0 text-center">
                    <i className="fas fa-user-circle fs-1"></i>
                  </Col>
                  <Col className="px-0">
                    <h6 className="fs-5 mb-0">Jagadeesh</h6>
                    <small className="comments">
                      <i className="far fa-clock"></i>
                      <span> &nbsp;1 hour(s) ago</span>
                    </small>
                    <p>
                      “Honestly, I possess all the skills and experience that
                      you're looking for. I'm pretty confident that I am the
                      best candidate for this job role.
                    </p>
                  </Col>
                </Row>
              </Alert>
            </Card.Footer>
          </Card>
        </Col>
        <Col md={3} className="px-0">
          <Card className="shadow">
            <Card.Body>
              <h5>Interview Questions</h5>
              <Nav className="flex-column">
                <Nav.Link href="#" className="pb-0">
                  HTML Interview QA
                </Nav.Link>
                <Nav.Link href="#" className="pb-0">
                  CSS Interview QA
                </Nav.Link>
                <Nav.Link href="#" className="pb-0">
                  Bootstrap Interview QA
                </Nav.Link>
                <Nav.Link href="#" className="pb-0">
                  React Interview QA
                </Nav.Link>
                <Nav.Link href="#" className="pb-0">
                  Redux Interview QA
                </Nav.Link>
                <Nav.Link href="#" className="pb-0">
                  NodeJs Interview QA
                </Nav.Link>
                <Nav.Link href="#" className="pb-0">
                  MongoDB Interview QA
                </Nav.Link>
                <Nav.Link href="#" className="pb-0">
                  MySQL Interview QA
                </Nav.Link>
                <Nav.Link href="#" className="pb-0">
                  DSA Interview QA
                </Nav.Link>
              </Nav>
            </Card.Body>
          </Card>
        </Col>
      </Row>
      <Footer />
    </>
  );
};

export default InterviewsQA;
